import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/common/PageHero";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { fileUrl, useC } from "../context/SiteData";
import { API } from "../lib/api";


const Blog = () => {
  const [posts, setPosts] = useState(null);
  const c = useC();

  useEffect(() => {
    axios.get(`${API}/blog`).then(({ data }) => setPosts(data.posts)).catch(() => setPosts([]));
  }, []);

  return (
    <>
      <PageHero
        title={c.ph_blog_title}
        subtitle={c.ph_blog_subtitle}
        desc={c.ph_blog_desc}
      />
      <section data-testid="blog-list" className="section-y">
        <div className="container-x">
          {!posts ? (
            <p className="text-sm text-ink-400">Yükleniyor...</p>
          ) : posts.length === 0 ? (
            <div className="border border-dashed border-line bg-cream-100 p-16 text-center">
              <p className="text-lg font-bold tracking-tight text-ink-900">Yakında</p>
              <p className="mt-2 text-sm text-ink-500">İlk yazılarımız çok yakında burada olacak.</p>
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={Math.min(i * 0.08, 0.3)} className="h-full">
                  <Link
                    to={`/blog/${p.slug}`}
                    data-testid={`blog-card-${p.slug}`}
                    className="group card-lift flex h-full flex-col border border-line bg-white hover:bg-cream-100"
                  >
                    {p.cover_path && (
                      <div className="overflow-hidden">
                        <img src={fileUrl(p.cover_path)} alt={p.title} loading="lazy"
                          className="aspect-[16/10] w-full object-cover saturate-[0.92] transition-[transform,filter] duration-700 group-hover:scale-[1.03] group-hover:saturate-100" />
                      </div>
                    )}
                    <div className="flex flex-1 flex-col p-6">
                      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ink-400">
                        {new Date(p.created_at).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" })}
                      </p>
                      <h2 className="mt-2 text-lg font-bold tracking-tight text-ink-900 transition-transform duration-500 group-hover:translate-x-1 sm:text-xl">
                        {p.title}
                      </h2>
                      {p.excerpt && <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-500">{p.excerpt}</p>}
                      <span className="link-arrow mt-5 border-t border-line pt-4">
                        Okumaya Devam Et <ArrowRight size={15} />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Blog;
